import React, { useState } from "react";
import { Alert, Box, Button, TextField } from "@mui/material";
import { Link } from "react-router-dom";

import { requestNetworkPortalPasswordReset } from "../../services/coreNetworkPortal";
import TalentAuthLayout from "./TalentAuthLayout";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const TALENT_LOGIN_IMAGE_URL = "https://images.pexels.com/photos/17771078/pexels-photo-17771078.jpeg";

export default function TalentForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  async function handleSubmit(event) {
    event.preventDefault();
    try {
      setLoading(true);
      setError("");
      const response = await requestNetworkPortalPasswordReset(email);
      setMessage(response?.message || "If an account exists for that email, a password reset link has been sent.");
    } catch (requestError) {
      setError(requestError?.response?.data?.message || requestError.message || "Unable to request password reset.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <TalentAuthLayout imageUrl={TALENT_LOGIN_IMAGE_URL} imagePosition="center 42%">
      <Box component="form" onSubmit={handleSubmit}>
        <nav className="talent-auth-pagination" aria-label="Talent account navigation">
          <Button component={Link} to="/talent/login" size="small" startIcon={<ArrowBackIcon />}>
            Back to login
          </Button>
        </nav>
        <header>
          <span className="talent-auth-kicker">Talent Portal</span>
          <h1 className="talent-auth-heading">Forgot Password</h1>
        </header>
        <Box aria-live="polite">
          {message ? <Alert className="talent-auth-alert" severity="success">{message}</Alert> : null}
          {error ? <Alert className="talent-auth-alert" severity="error">{error}</Alert> : null}
        </Box>
        <div className="talent-auth-fields">
          <TextField
            label="Email"
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
            fullWidth
            autoComplete="email"
          />
          <Button className="talent-auth-submit" type="submit" variant="contained" disabled={loading}>
            {loading ? "Sending..." : "Send Reset Link"}
          </Button>
        </div>
      </Box>
    </TalentAuthLayout>
  );
}
